import { provinces } from "../../mockData/province-mock";
import { districts } from "../../mockData/districts-mock";
import { subDistricts } from "../../mockData/subDistrict-mock";
import { zipcodes } from "../../mockData/zipcode-mock";
import { config } from "../../constants";

export const FETCH_PROVINCES = "FETCH_PROVINCES";
export const FETCH_PROVINCES_SUCCESS = "FETCH_PROVINCES_SUCCESS";
export const FETCH_PROVINCES_FAILURE = "FETCH_PROVINCES_FAILURE";

export const FETCH_DISTRICTS = "FETCH_DISTRICTS";
export const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
export const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export const FETCH_SUBDISTRICTS = "FETCH_SUBDISTRICTS";
export const FETCH_SUBDISTRICTS_SUCCESS = "FETCH_SUBDISTRICTS_SUCCESS";
export const FETCH_SUBDISTRICTS_FAILURE = "FETCH_SUBDISTRICTS_FAILURE";

export const FETCH_ZIPCODES = "FETCH_ZIPCODES";
export const FETCH_ZIPCODES_SUCCESS = "FETCH_ZIPCODES_SUCCESS";
export const FETCH_ZIPCODES_FAILURE = "FETCH_ZIPCODES_FAILURE";

const mockup = false;

export const fetchProvinces = () => (dispatch) => {
	dispatch({ type: FETCH_PROVINCES });
	if (mockup) {
		// return dispatch({ type: FETCH_PROVINCES_SUCCESS, payload: {} });
		return dispatch({ type: FETCH_PROVINCES_SUCCESS, payload: provinces });
	} else {
		return fetch(config.utilsAddress+'/getProvince', {
			// method: "GET", // *GET, POST, PUT, DELETE, etc.
			method: "GET",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("access_token")
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer" // no-referrer, *client
		})
			.then(res => res.json())
			.then(data => {
				dispatch({ type: FETCH_PROVINCES_SUCCESS, payload: data });
			})
			.catch((error) => dispatch({ type: FETCH_PROVINCES_FAILURE }));
	}
};

export const fetchDistricts = () => (dispatch) => {
	dispatch({ type: FETCH_DISTRICTS });
	if (mockup) {
		// return dispatch({ type: FETCH_DISTRICTS_SUCCESS, payload: {} });
		return dispatch({ type: FETCH_DISTRICTS_SUCCESS, payload: districts });
	} else {
		return fetch(config.utilsAddress+'/getAmphor', {
			// method: "GET", // *GET, POST, PUT, DELETE, etc.
			method: "GET",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("access_token")
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer" // no-referrer, *client
			//body: JSON.stringify(data) // body data type must match "Content-Type" header
		})
			.then(res => res.json())
			.then(data => {
				dispatch({ type: FETCH_DISTRICTS_SUCCESS, payload: data });
			})
			.catch((error) => dispatch({ type: FETCH_DISTRICTS_FAILURE }));
	}
};

export const fetchSubDistricts = () => (dispatch) => {
	dispatch({ type: FETCH_SUBDISTRICTS });
	if (mockup) {
		// return dispatch({ type: FETCH_SUBDISTRICTS_SUCCESS, payload: {} });
		return dispatch({ type: FETCH_SUBDISTRICTS_SUCCESS, payload: subDistricts });
	} else {
		return fetch(config.utilsAddress+'/getTumbon', {
			// method: "GET", // *GET, POST, PUT, DELETE, etc.
			method: "GET",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("access_token")
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer" // no-referrer, *client
			//body: JSON.stringify(data) // body data type must match "Content-Type" header
		})
			.then(res => res.json())
			.then(data => {
				dispatch({ type: FETCH_SUBDISTRICTS_SUCCESS, payload: data });
			})
			.catch((error) => dispatch({ type: FETCH_SUBDISTRICTS_FAILURE }));
	}
};

export const fetchZipCodes = () => (dispatch) => {
	dispatch({ type: FETCH_ZIPCODES });
	if (mockup) {
		// return dispatch({ type: FETCH_ZIPCODES_SUCCESS, payload: {} });
		return dispatch({ type: FETCH_ZIPCODES_SUCCESS, payload: zipcodes });
	} else {
		return fetch(config.utilsAddress+'/getZipCode', {
			// method: "GET", // *GET, POST, PUT, DELETE, etc.
			method: "GET",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("access_token")
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer" // no-referrer, *client
		})
			.then(res => res.json())
			.then(data => {
				dispatch({ type: FETCH_ZIPCODES_SUCCESS, payload: data });
			})
			.catch((error) => dispatch({ type: FETCH_ZIPCODES_FAILURE }));
	}
};
